import {Button, Form, Input, InputNumber, Modal, Select, Spin, Switch, Table} from "antd";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useForm} from "antd/es/form/Form";

const {Option} = Select;

const Services = () => {
    const {t} = useTranslation();
    const [services, setServices] = useState([]);
    const [categories, setCategories] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [editData, setEditData] = useState(null);
    const [form] = useForm();

    useEffect(() => {
        if (!isModalOpen) {
            form.resetFields();
            setEditData(null);
        }
    }, [isModalOpen])

    const getCategories = () => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}/admin/category/get-categories-services`,
                {
                    withCredentials: true,
                }
            )
            .then((response) => {
                const {data} = response.data;
                let finalServices = [];
                let categories = [];
                data.forEach(item => {
                    categories.push({
                        name: item.name,
                        _id: item._id
                    });
                    item.services.forEach(service => {
                        finalServices.push({
                            key: service._id,
                            categoryName: item.name,
                            categoryId: item._id,
                            service: service.name,
                            publicValue: service.publicValue,
                            percentage: service.workPercentage,
                            value: service.publicValue + ((service.publicValue * service.workPercentage) / 100),
                            createdAt: service.createdAt,
                            isActive: service.isActive
                        })
                    });
                });
                setServices(finalServices);
                setCategories(categories);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getCategories()
    }, []);

    const updateStatus = async (id, isActive) => {
        try {
            setLoading(true);
            axios
                .put(
                    `${process.env.REACT_APP_API_URL}/admin/category/${id}/update-service-status`,
                    {
                        isActive
                    },
                    {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    setLoading(false);
                    getCategories();
                    setIsModalOpen(false);
                })
                .catch((error) => {
                    setLoading(false);
                });
        } catch (errorInfo) {
            setLoading(true);
            // Handle validation errors
            console.log("Validation failed:", errorInfo);
        }
    };

    const handleOk = async () => {
        await form.validateFields();
        const formData = form.getFieldsValue();
        try {
            setLoading(true);
            if (editData) {
                axios
                    .put(
                        `${process.env.REACT_APP_API_URL}/admin/category/update-category`,
                        {
                            services: [{
                                workPercentage: formData.percentage,
                                publicValue: formData.price,
                                serviceId: editData.key,
                                name: formData.title
                            }],
                            categoryId: editData.categoryId
                        },
                        {
                            withCredentials: true,
                        }
                    )
                    .then((response) => {
                        setLoading(false);
                        getCategories();
                        setIsModalOpen(false);
                        setEditData(null);
                    })
                    .catch((error) => {
                        setLoading(false);
                    });
            } else {
                axios
                    .post(
                        `${process.env.REACT_APP_API_URL}/admin/category/add-service`,
                        {
                            workPercentage: formData.percentage,
                            publicValue: formData.price,
                            categoryId: formData.category,
                            name: formData.title
                        },
                        {
                            withCredentials: true,
                        }
                    )
                    .then((response) => {
                        setLoading(false);
                        getCategories();
                        setIsModalOpen(false);
                    })
                    .catch((error) => {
                        setLoading(false);
                    });
            }
        } catch (errorInfo) {
            setLoading(true);
            // Handle validation errors
            console.log("Validation failed:", errorInfo);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return <>
        <div className={'flex gap-4 items-center justify-end mb-3'}>
            <Button type="primary" className="text-white bg-blue-500"
                    onClick={() => setIsModalOpen(true)}>{t("Add New Service")}</Button>
        </div>
        <Spin spinning={loading}>
            <Table columns={[
                {
                    title: 'Category',
                    dataIndex: 'categoryName',
                    key: 'categoryName',
                },
                {
                    title: 'Service',
                    dataIndex: 'service',
                    key: 'service',
                },
                {
                    title: 'Public Value',
                    dataIndex: 'publicValue',
                    key: 'publicValue',
                },
                {
                    title: 'Platform percentage',
                    dataIndex: 'percentage',
                    key: 'percentage',
                },
                {
                    title: 'Total Value',
                    dataIndex: 'value',
                    key: 'value',
                },
                {
                    title: 'Is Active',
                    dataIndex: 'isActive',
                    key: 'isActive',
                    render: (text, record) => {
                        return <Switch onChange={(checked) => {
                            updateStatus(record.key, checked);
                        }} title={'Active'} checked={text}/>
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    render: (text, record) => (
                        <span>
          <Button type="primary" className="text-white bg-blue-500"
                  onClick={() => {
                      form.setFieldsValue({
                          percentage: record.percentage,
                          price: record.publicValue,
                          category: record.categoryId,
                          title: record.service
                      });
                      setIsModalOpen(true);
                      setEditData(record);
                  }}>Edit</Button>
        </span>
                    ),
                },
            ]} dataSource={services}/>
        </Spin>

        <Modal
            width={400}
            centered
            open={isModalOpen}
            onOk={handleOk}
            okType="default"
            okText="Save"
            cancelText="cancel"
            onCancel={handleCancel}
        >
            <div className="flex space-y-6 flex-col ">
                <div>
                    <p className="font-bold text-xl text-[#001529]">
                        {editData ? t("Update Service") : t("Add new Service")}
                    </p>
                </div>
                <div className="">
                    <Form
                        form={form}
                        className="w-full mx-auto p-4"
                        layout="vertical"
                    >
                        <div className="flex flex-col">
                            <label htmlFor="title">{t("Category")}</label>
                            <Form.Item
                                name="category"
                                rules={[
                                    {
                                        required: true,
                                        message: t("Please select category"),
                                    },
                                ]}
                            >
                                <Select
                                    id="category"
                                    placeholder={t("Please select category")}
                                >
                                    {categories.map((category, index) => (
                                        <Option value={category._id} key={index}>{category.name}</Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="flex flex-col">
                            <label htmlFor="title">{t("Service Name")}</label>
                            <Form.Item
                                name="title"
                                rules={[
                                    {required: true, message: t("Please enter a service Name")},
                                    {
                                        max: 50,
                                        message: t("Title must not exceed 50 characters"),
                                    },
                                ]}
                            >
                                <Input id="title" placeholder={t("Enter your service Name")}/>
                            </Form.Item>
                        </div>
                        <div className="flex flex-col">
                            <label htmlFor="title">{t("Base Price")}</label>
                            <Form.Item
                                name="price"
                                rules={[
                                    {required: true, message: t("Price is required")},
                                ]}
                            >
                                <InputNumber className={'w-full'} id="price" min={1}/>
                            </Form.Item>
                        </div>
                        <div className="flex flex-col">
                            <label htmlFor="title">{t("Platform fee")} %</label>
                            <Form.Item
                                name="percentage"
                                rules={[
                                    {required: true, message: t("Percentage is required")},
                                ]}
                            >
                                <InputNumber className={'w-full'} id="percentage" min={1}/>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
        </Modal>
    </>
}

export default Services;
